<template>
  <div>
    <el-container >
      <el-header class="el-header">
        <div style="display: flex" class="el-row">
          <div><el-image :src="logo"  style="height:80px;width: 80px;"></el-image></div> 
         <div class="grid-content bg-purple-light" style="width:530px" ><div> 天津大学浙江研究院</div><div>实验室安全教育培训与管理系统</div></div>
          <!-- <div class="grid-content bg-purple-light" style="width:430px" ><div> 这还是一个测试系统</div><div>这还是个测试系统管理系统</div></div> -->
          <div style="margin-left : 600px">
          </div>
          <div style="height:80px;width: 100px;">
            <el-image v-if = "userInfo.headImag != null && userInfo.headImag != ''" :src="userInfo.headImag" class="headImag" :fit = "'fit'"></el-image>
            <el-avatar v-else style="display: flex; background-color: rgb(47, 47, 228); height:80px;width: 80px; align-items: center; justify-content: space-around; "> {{ userInfo.fullName  }} </el-avatar>
          </div>
          <div style="height:80px ;width: 100px; display: flex; align-items: flex-end;">
            <el-tag type="danger">{{ userInfo.fullName }}</el-tag>
            <!-- <el-tag @click.native = "handleSelect('7')" style="margin-left:10px; cursor: pointer;"  size="" type="danger">个人中心</el-tag> -->
          </div>
          <div style="height:80px ;width: 100px; display: flex; align-items: flex-end;">
            <el-dropdown >
              <span class="el-dropdown-link">
                {{ localRole.remark }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for=" item in roleList" @click.native="handleCommand(item.id)" :key ="item.id" >{{ item.remark }}</el-dropdown-item>
                <el-dropdown-item @click.native="logoutHandle()">退出</el-dropdown-item>
                <el-dropdown-item @click.native="goCtrHome()"  v-if="admin" >到后台</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
        </div>
        </div>
        <div> 
        <el-menu 
          :default-active="defaultActive"
          class="el-menu"
          mode="horizontal"
          @select="handleSelect"
          background-color="#0162c3"
          text-color="#fff"
          :router="false"
          active-text-color="#ffd04b">
          <el-menu-item  class="el_menu_item" index="1">首页</el-menu-item>
          <el-menu-item  class="el_menu_item" index="2">通知公告</el-menu-item>
          <el-menu-item  class="el_menu_item" index="3">知识题库</el-menu-item>
          <el-menu-item  class="el_menu_item" index="4">安全知识</el-menu-item>
          <el-menu-item  class="el_menu_item" index="5">规章制度</el-menu-item>
          <el-menu-item  class="el_menu_item" index="6">办事指南</el-menu-item>
          <el-menu-item  class="el_menu_item" index="8">安全管理</el-menu-item>
          <el-menu-item  class="el_menu_item" index="9">安全责任书</el-menu-item>
          <!-- <el-menu-item  class="el_menu_item" index="7">个人中心</el-menu-item> -->
        </el-menu>
      </div>
      </el-header>
      <div class="main-div">
         <iframe class="iframe" :src="pcIndexIframeSrc" width="100%" height="100%" scrolling="no" frameborder="0"></iframe>
      </div>
      <el-footer>
        <el-image :src="logo"  style="height:40px"></el-image>
        <span>天津大学浙江研究院</span></el-footer>
    </el-container>
  </div>
</template>                        
  <script>
    // 引入组件
    import logo from "@/assets/image/yuanhui.png"
    import SERVICE_URL from '@/api/url'
    import {MESSAGE_DURATION} from  '@/api/constant'
    import axios from  '@/api/axiosConfig'
    import { TOKEN_ID } from '@/mutation/mutConst'
    export default {
       name : 'pc_index',
       data() {
        return {
          logo,
          admin : false,
          defaultActive : '1',
          pcIndexIframeSrc : SERVICE_URL +  "/#/pc_home",
          userInfo :{
            headImag:'',
            usrName:'',
            fullName:'',
            id :''
          },
          localRole :{
            id:'',
            roleName:'',
            remark:''
          },
          roleList :[]
        }
       },
       methods : {
        logoutHandle () {
          this.$confirm('即将要退出登录!', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.doLogout()
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消删除！'
            });
          })
        },
        doLogout(){
          let dat = {}
          let url = "/bc/exa/usr/logout"
          let s = JSON.stringify(dat)  
          axios.post(url, s).then((response) => {
            if (response.data.code === 0){
              this.$store.commit(TOKEN_ID, '')
              this.$router.push({path :'/'})
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
          }).catch( (err) => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
          })
        },
        handleCommand(roleId){
          if(roleId == this.localRole.id){
            return
          }
          if(this.roleList.length != 0){
            for( let i = 0 ; i< this.roleList.length; i++){
              let itm = this.roleList[i]
              if(itm.id == roleId){
                this.localRole.id =roleId
                this.localRole.roleName =itm.roleName
                this.localRole.remark =itm.remark
                return 
              }
            }
            this.$message({
              showClose: true,
              message: '未查询到该角色',
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        },
        handleSelect(index){
          if(index == null) {
            return 
          }
          let newSrc = ''
          if("1" == index ){
            newSrc = SERVICE_URL +   "/#/pc_home"
          }else if("2" == index ){
            newSrc = SERVICE_URL +   "/#/pc_notice"
          }else if("3" == index ){
            newSrc = SERVICE_URL +   "/#/pc_qm"
          }else if("4" ==index ){
            newSrc = SERVICE_URL +   "/#/pc_kn"
          } else if("5" ==index ){
            newSrc = SERVICE_URL +   "/#/pc_reg"
          }else if("6" ==index ){
            newSrc = SERVICE_URL +   "/#/pc_guid"
          }else if("8" ==index ){
            newSrc = SERVICE_URL +   "/#/pc_storeroom"
          }else if("9" ==index ){
            newSrc = SERVICE_URL +   "/#/pc_safe_book"
          }
          this.pcIndexIframeSrc = newSrc
        },

        handleSelectSelf(active){

          this.pcIndexIframeSrc = SERVICE_URL +   "/#/pc_self/" + active
        },
        logout(){

        },
        goCtrHome(){
          this.$router.push({path: '/pc_ctr_index'})
        },
        initRoleList() {
          let url = "/bc/exa/menu/getMenusAndRoles"
          let data = {}
          let s = JSON.stringify(data)  
          axios.post(url, s).then((response) => {
            if (response.data.code === 0){
              let resData = response.data.data

              // resData.forEach(t=> this.asignRoleInfoForm.roleList.push(t)) 
              // this.asignRoleInfoForm.roleList.forEach(t=>{
              //   if(t.LAY_CHECKED){
              //     this.$refs.multipleTable.toggleRowSelection(t, true)
              //   }
              // })

              this.userInfo = {...resData.usrInfo }
              
              if(resData.listRoles != null && resData.listRoles.length != 0){
                console.log(resData.listRoles)
              
                resData.listRoles.forEach(t => {
                  this.roleList.push(t)
                  if(t.roleName == 'usr'){
                    this.localRole = {...t}
                  }
                  if(t.roleName == 'admin') {
                    this.admin = true
                  }
                  if(this.localRole.id == '' ){
                    this.localRole = {...t}
                  }
                })
              }
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
          }).catch( (err) => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
          })
        }
       },
       created(){
         setTimeout(()=>{this.initRoleList()},200)
       },
       mounted() {
       // 父页面接受子页面的传值
        window.addEventListener('message', (e) => {
          this.defaultActive = e.data.data
          
          if(this.defaultActive == 7){
            let active = e.data.active
            setTimeout(() => {
              this.handleSelectSelf(active)
            }, 200);
          }else{
              setTimeout(() => {
              this.handleSelect(e.data.data)
            }, 200);
          }
        })
      },
    }
  </script>
  
  <style lang="less" scoped>
   .el-footer {
      position: fixed;
      bottom :0;
      left: 0;
      z-index: 1030;
      box-shadow: 0 1px 0 0 rgba(0, 0, 0, .05);
      width: 100%;
      height: 50px !important;
      background-repeat: repeat-x;
      color: #0162c3;
      text-align: center;
      background-color:#384868;
      line-height: 40px;
    }

    .main-div  {
      position: fixed;
      width: 1400px;
      top : 125px;
      left: 0;
      right: 0;
      margin:auto;
      background-color:ghostwhite;
      color: #333;
      text-align: center;
      height: calc(100% - 165px);
      overflow: hidden;
    }
    body > .el-container {
      margin-bottom: 40px;
    }


  .el-row {
    padding: auto;
    margin: auto;
    height: 300px;
    width: 1400px;
    font-size: large;
    text-align: center;
  }
  .el-row-titile{
    padding: auto;
    margin: auto;
    height: 10px;
    width: 1400px;
    font-size: large;
    text-align: center;
    }
                                                                                                             

  // /deep/.main-div::-webkit-scrollbar {
  //     width: 0px; // 横向滚动条
  //     height: 0px; // 纵向滚动条 必写
  // }
  // /deep/.main-div::-webkit-scrollbar-thumb {
  //     background-color: #dde;
  //     border-radius: 3px;
  // }


  .el-header{
      position: fixed;
      top: 0;
      left:  0;
      z-index: 1030;
      margin:auto;
      box-shadow: 0 1px 0 0 rgba(0, 0, 0, .05);
      width: 100%;
      height: 125px !important;
      background-repeat: repeat-x;
     // color: #0162c3;
      text-align: center;
      background-color:#fff;
      line-height: 40px;
    .el-menu  {
      
      margin: auto;
      padding: auto;
      overflow: hidden;
      height: 40px;
      width: 1400px;
    }
  
    

   .el_menu_item {
      display: flex;
      height: 40px;
      // line-height: 40px;
      width: 175px;
      justify-content: space-around;
      box-sizing: border-box;
      align-items:center ;
      // text-align: center;
      font-size: 20px;
      background: #629d9b;
    }

  .el-row {
    padding:  2px;
    background-color: #fff;
    margin: auto;
    height: 85px;
    width: 1400px;
    font-size: large;
    text-align: center;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .grid-content{
    color: #0162c3 ;
    font-size: 30px;
  }
  .headImag{

    width: 80px;
    height: 80px;
    border-radius: 50%;
  }

  .black{
    margin: 0px;
    display: block;
  }

  }
  </style>
  


// WEBPACK FOOTER //
// src/pc_pages/pc_index.vue